import { NoDataContent } from './styles'
import NoDataImageSrc from '../../../../assets/dashboard/nodata-image.png'

const NoData = () => {
  return (
    <NoDataContent>
      <img
        src={NoDataImageSrc}
        alt="Ilustração de uma pessoa interagindo com um painel de informações"
        className="image-svg"
      />
      <div className="text">
        <h2 className="title">Precisamos de mais informações para calcularmos seu desempenho</h2>
        <p className="description">
          Inicie seus estudos para que possamos calcular suas métricas de desempenho e mostrar sua
          evolução.
        </p>
      </div>
    </NoDataContent>
  )
}

export default NoData
